(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-blog-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
    $('.press-blog-slider').slick({
        arrows: true,
        dots: true, 
adaptiveHeight: true,
        prevArrow: '<div class="logo-slider-prev-btn"><svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 20L1 10.5L11 1" stroke="#000000" stroke-linecap="round"/></svg></div>',
        nextArrow: '<div class="logo-slider-next-btn"><svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L11 10.5L1 20" stroke="#000000" stroke-linecap="round"/></svg></div>',
    });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-section-contact"]) return;
  try {
    
$(document).ready(function () {
    $('.contact-info_items a').each(function (index) {
        if ($(this).attr('href') == window.location.pathname) {
            $(this).addClass('active');
        }
    });
});


  } catch(e) { console.error(e); }
})();
})();
